import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';
import { CONSTANT } from '../../utils/constant';
import { getLocalizedStrings } from '../../misc';

// SOF1 / SOF-3356 — order-access dropdown field for Sales Manager + Dealer.
// Label key path matches SOF2 verbatim:
//   USERS.USER_AUTHENTICATION.REGISTRATION_SCHEMA_MESSAGES.REQUIRES_ORDER_ACCESS_LABEL
// Option labels (`Yes` / `No`) are rendered inline in JSX, matching SOF2.
// Same field object is consumed by the registration form (US1) and the
// Manage Account form (US1 / US4).
const OrderAccess = ({ labels, errors, touched }) => {
  const {
    KEYS: {
      REQUIRES_ORDER_ACCESS: { YES, NO }
    }
  } = CONSTANT;

  const {
    USERS: {
      USER_AUTHENTICATION: {
        REGISTRATION_SCHEMA_MESSAGES: { REQUIRES_ORDER_ACCESS_LABEL }
      }
    }
  } = getLocalizedStrings();

  return (
    <>
      <Label labelName={REQUIRES_ORDER_ACCESS_LABEL} />
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1.5rem' }}
        className={`frg-select-container color-light input-container ${
          errors.requiresOrderAccess && touched.requiresOrderAccess
            ? 'error'
            : ''
        }`}
      >
        <Field
          as="select"
          name="requiresOrderAccess"
          className="select-style"
        >
          <option disabled value="">
            {labels.SELECT_OPTION || 'Select'}
          </option>
          <option value={YES}>Yes</option>
          <option value={NO}>No</option>
        </Field>
        <div className="error_messages">
          <span className="frg-body-font-14px">
            {errors.requiresOrderAccess}
          </span>
        </div>
        <div id="username_error_icon" className="error_messages_icon">
          <img src={ErrorIcon} alt="error_icon" />
        </div>
      </div>
    </>
  );
};

OrderAccess.propTypes = {
  labels: PropTypes.shape({
    SELECT_OPTION: PropTypes.string
  }).isRequired,
  errors: PropTypes.shape({
    requiresOrderAccess: PropTypes.string
  }).isRequired,
  touched: PropTypes.shape({
    requiresOrderAccess: PropTypes.bool
  }).isRequired
};

export default OrderAccess;
